import React, { useRef } from 'react';
import styles from './EnquireButtonPopover.module.scss';
import { useRouter } from 'next/router';
import LinkWrapper from '@src/components/LinkWrapper';
import { handleEnquireButtonScrollToClick } from '@src/utils/scrollToEnquireForm';
import { useViewport } from '@src/hooks/useViewport';
import BoxIcon from '@src/elements/BoxIcon';
import { COLOR_SIDECAR_DARK } from '@src/types/colors';
import { useClickOutside } from '@src/hooks/useClickOutside';

interface EnquireButtonPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  anchorRef: React.RefObject<HTMLDivElement | null>;
  scrollToId: string;
  handleCloseMobileMenu?: (event: React.MouseEvent) => void;
}

const EnquireButtonPopover: React.FC<EnquireButtonPopoverProps> = ({
  isOpen,
  onClose,
  anchorRef,
  scrollToId,
  handleCloseMobileMenu
}) => {
  const router = useRouter();
  const { width } = useViewport();
  const popoverRef = useRef<HTMLDivElement>(null);
  useClickOutside([popoverRef, anchorRef], onClose);

  return (
    <>
      {isOpen && (
        <div
          className={styles.popoverOverlay}
          onClick={onClose}
          role="presentation"
        >
          <div className={styles.popoverMenu} role="menu" ref={popoverRef}>
            <div className={styles.notch} />
            <ul>
              <li className={styles.menuItem}>
                <button
                  aria-label="General enquiry"
                  onClick={(event) => {
                    onClose();
                    handleEnquireButtonScrollToClick(
                      width,
                      router,
                      event,
                      handleCloseMobileMenu,
                      scrollToId
                    );
                  }}
                  role="menuitem"
                >
                  General enquiry
                  <BoxIcon
                    name="right-arrow-alt"
                    size="sm"
                    color={COLOR_SIDECAR_DARK}
                  />
                </button>
              </li>
              <li className={styles.menuItem}>
                <button
                  aria-label="Book a tour"
                  onClick={(event) => {
                    onClose();
                    handleEnquireButtonScrollToClick(
                      width,
                      router,
                      event,
                      handleCloseMobileMenu,
                      scrollToId,
                      true
                    );
                  }}
                  role="menuitem"
                >
                  Book a tour
                  <BoxIcon
                    name="right-arrow-alt"
                    size="sm"
                    color={COLOR_SIDECAR_DARK}
                  />
                </button>
              </li>
              <li className={styles.menuItem}>
                <LinkWrapper
                  href="/careers-at-levande/"
                  role="menuitem"
                  aria-label="Careers"
                >
                  Careers
                  <BoxIcon
                    name="right-arrow-alt"
                    size="sm"
                    color={COLOR_SIDECAR_DARK}
                  />
                </LinkWrapper>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default EnquireButtonPopover;
